import { List } from 'antd';
// import styled from 'styled-components';
// import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import phone from '../../../assets/images/phone.svg';
import wing from 'assets/images/wing.svg';
import person from 'assets/images/private.svg';
import userGuide from 'assets/images/f15-my-documents.svg';
import light from 'assets/images/light-bulb.svg';
import './Liststyle.less';
import ChevronRight from 'assets/images/home/chevron-right.svg';

// import NotificationBellWhite from '../../../assets/images/notification-bell-white.svg';

function GeneraliSupportList() {
  const data = [
    {
      tittle: 'life.support.contactUs',
      svg: wing,
    },
    {
      tittle: 'life.support.enquiry',
      svg: person,
    },
    {
      tittle: 'life.support.guide',
      svg: userGuide,
    },
    {
      tittle: 'life.support.frequently',
      svg: light,
    },
  ];
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const { data: lifeData, error: lifeError } = useLifeFaq();
  const TodetaileEven = (v: string) => {
    if (v == 'life.support.contactUs') {
      navigate('/ContactUs');
    } else if (v == 'life.support.enquiry') {
      navigate('/EnquiryFlow');
    } else if (v == 'life.support.guide') {
      navigate('/UserGuide');
    } else if (v == 'life.support.frequently') {
      navigate('/LifeFAQPage');
    }
  };
  return (
    <List
      style={{ background: '#fff', maxWidth: '680px', height: '330px' }}
      size="large"
      className="List"
      header={
        <div>
          <span className="headertittle">{t('life.support.header')}</span>
        </div>
      }
      bordered
      dataSource={data}
      renderItem={(item) => (
        <List.Item
          style={{ display: 'flex', fontFamily: 'Roboto400', fontSize: '20px', cursor: 'pointer' }}
          onClick={() => {
            TodetaileEven(item.tittle);
          }}
        >
          <span style={{ fontSize: '20px' }}>
            {/* <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" /> */}
            <img alt={item.tittle} src={item.svg} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
            {t(item.tittle)}
          </span>
          <span>
            <img src={ChevronRight} style={{ margin: '0  10px 0 0', width: '8px', height: '14px' }} />
          </span>
        </List.Item>
      )}
    />
  );
}
export default GeneraliSupportList;
